export default "__VITE_ASSET__D3NIb7dj__"